import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CardContent, CardHeader, Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Card, FormControl, InputLabel, InputAdornment, IconButton, OutlinedInput, ListItemSecondaryAction, useMediaQuery, InputBase } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import { MapGiz } from '../../helpers';
import { Delete, Search } from '@material-ui/icons';
import Form from './Form';

// Most of react-virtualized's styles are functional (eg position, size).
// Functional styles are applied directly to DOM elements.
// The Table component ships with a few presentational styles as well.
// They are optional, but if you want them you will need to also import the CSS file.
// This only needs to be done once; probably during your application's bootstrapping process.
import 'react-virtualized/styles.css';


import { TablaOqt } from './TablaOqt';
import { usePageTitleContext } from '../../contexts/PageTitle';

export const panelHeight = 650;

const List = (props) => {

  const isMd = useMediaQuery('(min-width:980px)');
  const history = useHistory();
  const { isFetching, lateralForm, removeItem, snack, config, index, list, data, page, count, filter, setSearchTerm, filterList, loadMore, noSavedChanges, editItem, updateLocalItem, searchTerm } = props;
  const [map, setMap] = useState({show: false, lat: undefined, lng: undefined});
  let { id } = useParams();
  const [term, setTerm] = useState(searchTerm);
  const { setPageTitle } = usePageTitleContext();
  const inputSearchRef = useRef();

  useEffect(() => {
    setPageTitle(config.caption, "", config.bodyColor);
    index()
      .catch(error => {
        snack.openAxiosError(error)
      });
  }, [])

  const canShowItem = useMemo(()=>{
    if(list.length === 0 && !term){
      return false;
    }
    if(filterList.length === 0 && term){
      return false;
    }
    return true;
  }, [list, filterList])
  
  useEffect(() => {
    if(id && lateralForm === "edit" && list.length === 0 && term === ""){
      history.push("Index");
    }
    if(list.length > 0 && !id && lateralForm === "" && !term){
      history.push("Edit/" + list[0].id);
    }
    if(filterList.length > 0 && !id && lateralForm === "" && term){
      history.push("Edit/" + filterList[0].id);
    }
  }, [list, filterList, id, lateralForm])
  
  useEffect(() => {
    setSearchTerm(term);
    filter(term)
      .catch(e => console.log(e));
  }, [term])
  
  const handleOnChangeConfirm = (item) => {
    if( lateralForm === "add" ){
      history.push("Edit/" + item.id);
    }
  }

  const handleChangeTerm = (value) => {
    setTerm(value);
  }

  const handleLoadMore = () => {
    //console.log("loadmore");
    loadMore(page + 1)
      .catch(error => {
        snack.openAxiosError(error)
      });
  }
  
  const handleRefresh = () => {
    index()
      .catch(error => {
        snack.openAxiosError(error)
      });
  }
  
  const handleAddClick = () => {
    if(id){
      history.push("../Add");
    }else{
      history.push("Add");
    }
  }

  const handleMapClose = () => {
    setMap({show: false, lat: undefined, lng: undefined});
  }

  const handleDeleteClick = (event, item, itemDescription) => {
    event.preventDefault();
    Swal
      .fire({
        icon: 'question',
        title: 'Eliminar elemento',
        html: `Está seguro de eliminar este elemento?<br/> <span>${itemDescription}</span>`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cerrar',
      })
      .then((result) => {
        if (result.isConfirmed) {
          removeItem(item)
            .then(()=>{
              snack.openSuccess('El elemento se eliminó correctamente.');
              history.replace("../Index");
            })
            .catch(error => {
              snack.openAxiosError(error)
            });
        }
      });

  }
  
  const saveChangeValues = () => {
    if(lateralForm === "edit" && noSavedChanges.state){
      editItem(noSavedChanges.values.id, noSavedChanges.values)
        .then(response => {
          updateLocalItem(response);
        })
        .catch(error => {
          snack.openAxiosError(error);
        });;
    } 
  }

  const handleItemClick = (row, event) => {
    event.preventDefault();
    if(id){
      saveChangeValues();
      history.push(`../Edit/${row.id}`);
    }else{
      history.push(`Edit/${row.id}`);
    }
  }


  return (
    <>
      <Dialog fullWidth onClose={handleMapClose} open={map.show} keepMounted={false} maxWidth="xl">
        <DialogTitle>Ubicación de la orden</DialogTitle>
        <DialogContent>
          <MapGiz readonly={true} point={map} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleMapClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={2} >
        <Grid item xs={isMd ? 4 : 12} md={6} lg={4} style={{height: panelHeight}}>
          <Card elevation={0} style={{height: "100%", minWidth: 300,  backgroundColor: config.bgColor || "white"}}>
            <CardHeader
              action={
                <>
                {
                  config.policy.add &&
                  <Button onClick={handleAddClick}>
                    Agregar
                  </Button>
                }
                </>
              }
              title={
                <FormControl 
                  variant="outlined" 
                  style={{
                    width: "100%",
                    backgroundColor: "#f7f7f7",
                    padding: "6px 4px 4px 8px",
                    borderRadius: 2,
                    marginTop: -4,
                    marginBottom: -4,
                  }} 
                >
                  <InputBase 
                    ref={inputSearchRef}
                    size="small"
                    type="text" 
                    endAdornment={
                      <InputAdornment position="start">
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                          onClick={()=>{
                            if(term){
                              setTerm("");
                            }
                          }}
                        >
                          {!term ? <Search /> : <Delete />}
                        </IconButton>
                      </InputAdornment>
                    }
                    onChange={e => handleChangeTerm(e.target.value)}
                    value={term}
                    placeholder="Filtro"
                  />
                </FormControl>
              }
            />
            <CardContent>
              <TablaOqt
                data={data}
                rows={term.length === 0 ? list : filterList} 
                columns={config.columns({
                  /*onDetails: config.policy.details && handleDetailsClick, 
                  onEdit: config.policy.edit && handleEditClick, 
                  onDelete: config.policy.delete && handleDeleteClick, 
                  onCopy: config.policy.copy && handleCopyClick,
                  onTimeline: config.policy.timeline && handleTimelineClick,
                  onMap: config.policy.map && handleMapClick,*/
                })}
                id={id}
                onLoadMore={handleLoadMore}
                onRefresh={handleRefresh}
                hasMore={page < count}
                infiniteScroll={term.length === 0}
                onDeleteClick={config.policy.delete && handleDeleteClick}
                showEndMessage={count > 1 || list.length > 10}
                onItemClick={handleItemClick}
              />
            </CardContent>          
          </Card>
        </Grid>

        <Grid item xs={isMd ? 8 : 12} md={6} lg={8} style={{minHeight: panelHeight}}>
          {((id && canShowItem) || lateralForm === "add") 
            ? <Form {...props} onChangeConfirm={handleOnChangeConfirm} action={lateralForm === "add"  ? "add" : "edit"} id={id}/>
            : <GreyCard/>
          }
        </Grid>
      </Grid>
    </>
  );
}

const GreyCard = () => {
  return (
    <Card elevation={0} style={{backgroundColor: "rgb(212, 212, 212)", height: "100%"}}>
      <CardHeader/>
      <CardContent></CardContent>          
    </Card>
  )
}

export default List;
